export const SP_ORDER_JOBS_LIST_FILTERED = "SP_ORDER_JOBS_LIST_FILTERED";
export const SP_ORDER_JOBS_LIST_FILTERED_SUCCESS = "SP_ORDER_JOBS_LIST_FILTERED_SUCCESS";
export const SP_ORDER_JOBS_LIST_FILTERED_ERROR = "SP_ORDER_JOBS_LIST_FILTERED_ERROR";